import React from "react";

const StatCard = ({ icon, value, label }) => {
    return (
        <div className="flex-1 aspect-square bg-white rounded-lg flex flex-col items-center justify-center text-center shadow-sm">
            <img
                src={icon}
                alt={label}
                className="h-8 w-8 object-contain mb-2"
            />
            <div className="semiBold text-lg">{value}</div>
            <div className="medium text-gray-700 text-sm">{label}</div>
        </div>
    );
};

export default StatCard;